var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { Box, Text } from 'elemental-react';
var InputField = function (_a) {
    var label = _a.label, labelVisible = _a.labelVisible, placeholder = _a.placeholder, error = _a.error, assistiveText = _a.assistiveText, _b = _a.value, value = _b === void 0 ? '' : _b, children = _a.children, props = __rest(_a, ["label", "labelVisible", "placeholder", "error", "assistiveText", "value", "children"]);
    // TODO: Fix up this horribly hacky conditional statement :D
    var showLabel = labelVisible !== false && (label && value && value.length > 0) || (labelVisible === true);
    return (_jsxs(Box, __assign({ width: "100%", flexDirection: "column" }, props, { children: [labelVisible !== false && (_jsx(Box, __assign({ mb: 2, opacity: showLabel ? 1 : 0 }, { children: _jsx(Text, __assign({ fontSize: 12, color: "#777777" }, { children: showLabel ? label : '.' }), void 0) }), void 0)), _jsx(Box, { children: React.isValidElement(children) ? children : children({ label: label, placeholder: placeholder, error: error, value: value }) }, void 0), _jsx(Box, __assign({ height: 16, mt: 1, opacity: (error || assistiveText) ? 1 : 0 }, { children: _jsx(Text, __assign({ fontSize: 12, color: error ? '#FF0000' : 'black' }, { children: error || assistiveText }), void 0) }), void 0)] }), void 0));
};
export default InputField;
